module.exports = __webpack_public_path__ + "static/media/1_review_icon.b479b830.svg";